import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getListaCalFiltrado,
  getListaCal,
  clearErrors,
  deleteProgCalTabla,
  postCalibracionTabla,
  subirReporteCalibracionTabla
} from '../../../redux/actions/dataactions';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
  IconButton,
  Grid,
  Typography,
  InputAdornment, Button
} from '@mui/material';
import { Link } from 'react-router-dom';
import './TablaCronogramaCal.css';
import {
  FaArrowLeft,
  FaCheck,
  FaCheckCircle,
  FaClipboardList,
  FaFilePdf,
  FaPlus,
  FaUpload,
  FaSearch,
} from 'react-icons/fa';
import DeleteIcon from '@mui/icons-material/Delete';
import CronogramaCalAuto from './CronogramaCalAuto';
import CronogramaCalDuplicarRango from './CronogramaCalDuplicarRango';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TablaCronogramaCalInd from './TablaCronogramaCalInd';
import moment from 'moment';

export class TablaCronogramaCal extends Component {
  constructor() {
    super();
    this.state = {
      horainicio: '',
      horafinal: '',
      fecha: '',
      numcertificado: '',
      errors: {},
      aprobado: {},
      open: false,
      opendelete: false,
      progid: '',
      equipoid: '',
      clienteid: '',
      selectedFile: null,

      // Filtros
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
    };
  };

  componentDidMount() {
    const { credentials } = this.props.user;
    const { clienteId } = this.props;
    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") responsable = credentials.handle;
    this.props.getListaCalFiltrado(clienteId, "01/01/1950", "01/01/2035", responsable);
  }

  // Buscar (local)
  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value || '' });
  };

  // Restablecer filtros y recargar full
  handleResetFiltros = () => {
    const { user, clienteId } = this.props;
    const credentials = user?.credentials || {};
    let responsable = credentials?.tipouser === 'Tecnico' ? (credentials.handle || '') : 'Todos';

    this.setState({
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
      errors: { ...this.state.errors, fechaInicio: null, fechaFin: null }
    });

    this.props.getListaCalFiltrado(clienteId, '01/01/1950', '01/01/2035', responsable);
  };

  // Filtro local por texto
  filterEquipos = () => {
    const { equiposcal } = this.props.data || {};
    const list = Array.isArray(equiposcal) ? equiposcal : [];
    const q = String(this.state.searchQuery || '').toLowerCase();

    const TEXT_FIELDS = [
      'idinventario', 'nombre', 'marca', 'modelo', 'serie', 'ubicacion', 'servicio', 'estado', 'fecha', 'mesnombre', 'lugar'
    ];

    const filtered = list.filter((item) =>
      TEXT_FIELDS.some((field) => {
        const val = item?.[field];
        return val != null && String(val).toLowerCase().includes(q);
      })
    );

    // Ordenar por fecha (robusto a DD/MM/YYYY o YYYY-MM-DD)
    const toDate = (s) => {
      const m = moment(s, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'], true);
      return m.isValid() ? m.toDate() : new Date(s);
    };
    return filtered.sort((a, b) => toDate(b.fecha) - toDate(a.fecha));
  };

  handleFiltrar = () => {
    const { credentials } = this.props.user;
    const { clienteId } = this.props;
    const { fechaInicio, fechaFin } = this.state;

    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") responsable = credentials.handle;

    const errors = {};
    if (!fechaInicio) errors.fechaInicio = 'Requerido';
    if (!fechaFin) errors.fechaFin = 'Requerido';
    if (Object.keys(errors).length) {
      this.setState({ errors: { ...(this.state.errors || {}), ...errors } });
      return;
    }

    this.props.getListaCalFiltrado(
      clienteId,
      moment(fechaInicio).format('DD/MM/YYYY'),
      moment(fechaFin).format('DD/MM/YYYY'),
      responsable
    );
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpenDelete = (rawdataprogid, rawdataequipoid, rawdataclienteid) => {
    this.setState({ opendelete: true, progid: rawdataprogid, equipoid: rawdataequipoid, clienteid: rawdataclienteid });
  };

  handleCloseDelete = () => {
    this.setState({ opendelete: false, errors: {}, aprobado: {} });
  };

  onFileChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  handleDelete = () => {
    this.props.deleteProgCalTabla(this.state.progid, this.props.clienteId);
    this.handleCloseDelete();
  }

  handleOpen = (rawdataprogid, rawdataequipoid, rawdatafecha, rawdatahora, rawdataidinv) => {
    this.setState({ open: true, progid: rawdataprogid, equipoid: rawdataequipoid, fecha: rawdatafecha, horainicio: rawdatahora, numcertificado: rawdataidinv });
  };

  handleClose = () => {
    const { credentials } = this.props.user;
    const { clienteId } = this.props;
    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") responsable = credentials.handle;

    if (this.state.aprobado.mensaje) {
      if (this.state.selectedFile) {
        const formData = new FormData();
        formData.append("myFile", this.state.selectedFile, this.state.selectedFile.name);
        this.props.subirReporteCalibracionTabla(
          formData, 
          this.state.equipoid, 
          clienteId, 
          this.state.aprobado.calibracionid || this.state.progid
        );
      }
      this.props.getListaCalFiltrado(clienteId, "01/01/1950", "01/01/2035", responsable);
      this.setState({ open: false, errors: {}, aprobado: {}, selectedFile: null });
    } else {
      this.setState({ open: false, errors: {}, aprobado: {}, selectedFile: null });
    }
  };

  handlePostCal = () => {
    const newCalibracion = {
      fecha: this.state.fecha,
      horainicio: this.state.horainicio,
      horafinal: this.state.horafinal,
      numcertificado: this.state.numcertificado,
      programacionid: this.state.progid
    };
    this.props.postCalibracionTabla(newCalibracion, this.props.clienteId, this.state.equipoid);
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { equiposcal, loadingcal } = this.props.data;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 150,
        renderCell: (params) => (
          <Fragment>
            <Tooltip title="Ver Perfil">
              <IconButton
                size="small"
                component={Link}
                to={`/dashboard/perfilcliente/equipo/${this.props.clienteId}/${params.row.equipoid}`}
                sx={{ color: '#03178C' }}
              >
                <FaClipboardList size={16} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Realizar Calibración">
              <span>
                <IconButton
                  size="small"
                  disabled={params.row.estado === 'Realizado'}
                  onClick={() =>
                    this.handleOpen(
                      params.row.progid,
                      params.row.equipoid,
                      params.row.fecha,
                      params.row.hora,
                      params.row.idinventario
                    )
                  }
                  sx={{ color: '#03178C' }}
                >
                  <FaPlus size={16} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Borrar Programación">
              <IconButton
                size="small"
                onClick={() =>
                  this.handleOpenDelete(
                    params.row.progid,
                    params.row.equipoid,
                    params.row.clienteid
                  )
                }
                sx={{ color: '#03178C' }}
              >
                <DeleteIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Fragment>
        ),
      },
      { field: 'idinventario', headerName: 'Id Inventario', width: 120 },
      { field: 'nombre', headerName: 'Nombre', width: 150 },
      { field: 'marca', headerName: 'Marca', width: 120 },
      { field: 'serie', headerName: 'Serie', width: 120 },
      { field: 'modelo', headerName: 'Modelo', width: 120 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
      { field: 'servicio', headerName: 'Servicio', width: 120 },
      { field: 'fecha', headerName: 'Fecha', width: 120 },
      { field: 'mesnombre', headerName: 'Mes', width: 120 },
      { field: 'estado', headerName: 'Estado', width: 120 },
      { field: 'lugar', headerName: 'Lugar', width: 120 },
    ];

    const filteredRows = this.filterEquipos();

    const mapeoequipos = !loadingcal ? (
      <div>
        <div className='inventory-links-grid'>
          <CronogramaCalAuto clienteId={this.props.clienteId} />
          <CronogramaCalDuplicarRango clienteId={this.props.clienteId} />
          <TablaCronogramaCalInd clienteId={this.props.clienteId} />
          <Fragment>
            <Link className='div-card-link' to={`/dashboard/perfilcliente/${this.props.clienteId}/cronocalperfil/uploadcal`} state={equiposcal} >
              <div className="dashing-cardcontent">
                <div className="dashing-cardtext">
                  <p className="dashing-text-card">
                    Subir Reportes
                  </p>
                </div>
                <div className="dashing-cardicon">
                  <FaUpload color="#FFFFFF" className="dashing-icon" />
                </div>
              </div>
            </Link>
          </Fragment>

          <Fragment>
            <Link className='div-card-link' to={`/dashboard/perfilcliente/cronogramacal/${this.props.clienteId}`} state={equiposcal} >
              <div className="dashing-cardcontent">
                <div className="dashing-cardtext">
                  <p className="dashing-text-card">
                    Ver en PDF
                  </p>
                </div>
                <div className="dashing-cardicon-green">
                  <FaFilePdf color="#FFFFFF" className="dashing-icon" />
                </div>
              </div>
            </Link>
          </Fragment>
        </div>

        {/* Filtros (con botones custom y lupa en búsqueda) */}
        <Box sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              size="small"
              label="Buscar programación"
              variant="outlined"
              value={this.state.searchQuery}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FaSearch style={{ opacity: 0.6 }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaInicio"
                id="fechaInicio"
                label="Desde"
                value={this.state.fechaInicio}
                onChange={this.handleChange}
                helperText={errors.fechaInicio}
                error={Boolean(errors.fechaInicio)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaFin"
                id="fechaFin"
                label="Hasta"
                value={this.state.fechaFin}
                onChange={this.handleChange}
                helperText={errors.fechaFin}
                error={Boolean(errors.fechaFin)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={this.handleFiltrar}
                size="medium"
                sx={{ height: '100%' }}
              >
                Filtrar
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={this.handleResetFiltros}
                size="medium"
                sx={{ height: '100%' }}
              >
                Restablecer
              </Button>
            </Grid>
          </Grid>
        </Box>

        <DataGrid
          rows={filteredRows || []}
          columns={columns}
          getRowId={(row) => row.progid}
          // ❌ Sin barra de búsqueda del DataGrid
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white'
            }
          }}
        />
      </div>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 500 }}>
        <CircularProgress size={50} color="primary" className="login-progress" />
      </Box>
    );

    return (
      <div>
        {mapeoequipos}

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          {this.state.aprobado.mensaje ? (
            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
            </div>
          ) : (
            <div>
              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Realizar Calibración
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} mt={2}>
                    <TextField className="login-input-email"
                      required
                      type="date"
                      name="fecha"
                      id="fecha"
                      label="Fecha de Realización"
                      value={this.state.fecha}
                      onChange={this.handleChange}
                      min="2019-01-01" max="2022-01-01"
                      fullWidth
                      helperText={errors.fecha}
                      error={errors.fecha ? true : false}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField className="login-input-email"
                      required
                      type="time"
                      name="horainicio"
                      id="horainicio"
                      label="Hora de Inicio"
                      value={this.state.horainicio}
                      onChange={this.handleChange}
                      min="2000-01-01" max="2022-01-01"
                      fullWidth
                      helperText={errors.horainicio}
                      error={errors.horainicio ? true : false}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField className="login-input-email"
                      required
                      type="time"
                      name="horafinal"
                      id="horafinal"
                      label="Hora Final"
                      value={this.state.horafinal}
                      onChange={this.handleChange}
                      min="2000-01-01" max="2022-01-01"
                      fullWidth
                      helperText={errors.horafinal}
                      error={errors.horafinal ? true : false}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField className="login-input-email"
                      required
                      type="text"
                      name="numcertificado"
                      id="numcertificado"
                      label="Numero del Certificado"
                      value={this.state.numcertificado}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.numcertificado}
                      error={errors.numcertificado ? true : false}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button variant="outlined" component="label" fullWidth size="small" sx={{ borderColor: '#03178C', color: '#03178C' }}>
                      {this.state.selectedFile ? this.state.selectedFile.name : "Subir Archivo Adjunto (Opcional)"}
                      <input type="file" hidden onChange={this.onFileChange} />
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
            </div>
          )}

          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <Tooltip title="Continuar">
                  <IconButton onClick={this.handleClose} size="small">
                    <FaCheckCircle color="#20B90C" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Subir Reporte de Calibración">
                  <IconButton onClick={this.handlePostCal} size="small">
                    <FaPlus color="#03178C" />
                  </IconButton>
                </Tooltip>
              )
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.opendelete}
          onClose={this.handleCloseDelete}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
              Estas seguro de borrar programación?
            </Typography>
          </DialogTitle>

          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseDelete} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              <Tooltip title="Borrar Programación">
                <IconButton onClick={this.handleDelete} size="small">
                  <DeleteIcon sx={{ color: '#03178C' }} />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TablaCronogramaCal.propTypes = {
  getListaCal: PropTypes.func.isRequired,
  getListaCalFiltrado: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  deleteProgCalTabla: PropTypes.func.isRequired,
  postCalibracionTabla: PropTypes.func.isRequired,
  subirReporteCalibracionTabla: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const mapActionsToProps = { getListaCalFiltrado, getListaCal, clearErrors, deleteProgCalTabla, postCalibracionTabla, subirReporteCalibracionTabla };
const mapStateToProps = state => ({
  data: state.data,
  user: state.user,
  UI: state.UI
})
export default connect(mapStateToProps, mapActionsToProps)(TablaCronogramaCal);
